import { VIMEO_REGEX, getYoutubeVideoId, prependProtocolToUrl } from '@bingads-webui-campaign-react/smart-component-util';

export const isVideoAvailable = (url) => {
  let oEmbedUrl;
  const videoUrl = prependProtocolToUrl(url);

  const id = getYoutubeVideoId(videoUrl);
  if (id) {
    const encodeUrl = encodeURIComponent(`https://www.youtube.com/watch?v=${id}`);
    oEmbedUrl = `https://www.youtube.com/oembed?url=${encodeUrl}`;
  } else if (VIMEO_REGEX.test(videoUrl)) {
    const encodeUrl = encodeURIComponent(videoUrl);
    oEmbedUrl = `https://vimeo.com/api/oembed.json?url=${encodeUrl}`;
  }

  if (!oEmbedUrl) {
    return Promise.resolve(false);
  }

  return fetch(oEmbedUrl, { method: 'GET' })
    .then((response) => {
      if (response.ok) {
        return true;
      }

      return false;
    });
};
